// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Avaliacoes_RunEvaluationInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /avaliacoes/runEvaluation
 *
 * Validates AI-evaluation requests: a chat_id and a list of criteria names
 * to evaluate the chat's messages against.
 */
import { registerContract } from './validate'

export interface Avaliacoes_RunEvaluationInput {
chat_id: string
criteria_names?: string[]
}

registerContract('Avaliacoes_RunEvaluationInput', {
  chat_id:        { type: 'string',  required: true },
  criteria_names: { type: 'array',   required: false },
})
